import React from 'react'

import compose  from 'vegas-js-core/src/functors/compose'
import isString from 'vegas-js-core/src/isString'
import ucFirst  from 'vegas-js-core/src/strings/ucFirst'

import initApp from '../../../../contexts/app/initApp'

import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import { Chip, Tooltip, Typography } from '@material-ui/core'

import grey from '@material-ui/core/colors/grey'

import LensIcon  from '@material-ui/icons/Lens'
import MapIcon   from '@material-ui/icons/Map'

import ThingCardChildren, { styles } from '../../ThingCardChildren'

import api from '../../../../configs/api'

import Course from '../../../../things/Course'
import Game   from '../../../../things/Game'
import Thing  from '../../../../things/Thing'
import Word   from '../../../../things/Word'

class ApplicationQuest extends ThingCardChildren
{
    createChild = ( child /*, editable = false*/ ) =>
    {
        if( child )
        {
            let { about } = child ;
            return (
            <div className='w-full flex justify-start pt-16'>
                { this.getCourse( about ) }
            </div> );
        }
        return null ;
    };

    getCardIcon = child => this.getAvatar( child ) ;

    getCardLabel = child =>
    {
        if( child instanceof Thing )
        {
            const { lang } = this.props ;

            let label = child.getLocaleAlternateName(lang) ;

            if( !isString(label) || label === '' )
            {
                label = child.getLocaleName(lang) ;
            }

            if( !isString(label) || label === '' )
            {
                label = this.getLocale().unknown ;
            }

            if( isString(label) )
            {
                if( isString(label) )
                {
                    return ucFirst(label) ;
                }
            }
        }
        return this.props.cardLabel ;
    };

    getCardSubLabel = child =>
    {
        if( child instanceof Thing )
        {
            const { lang } = this.props ;
            let label = child.getLocaleAlternateName(lang) ;
            if( isString(label) && label !== '' )
            {
                label = child.getLocaleName( lang ) ;
                if( isString(label) )
                {
                    if( isString(label) )
                    {
                        return (
                        <Typography variant = 'caption'>
                            { ucFirst(label) }
                        </Typography>
                        ) ;
                    }
                }
            }
        }
        return this.props.cardSubLabel ;
    };

    getCourse = course =>
    {
        if( course instanceof Course )
        {
            const { history, lang } = this.props ;

            let {
                headline,
                name,
                status ,
                url
            } = course ;

            let label ;
            let icon ;

            if( headline )
            {
                label = ucFirst(course.getLocaleHeadline(lang)) ;
            }

            if( status instanceof Word )
            {
                let { color } = status ;
                if( isString( color ) )
                {
                    color = '#' + color ;
                }
                else
                {
                    color = grey[200];
                }

                icon = <LensIcon style={{ color }}/> ;

                let tip = status.getLocaleName(lang) ;
                if( isString(tip) && tip !== '' )
                {
                    icon = (
                    <Tooltip
                        placement = 'top'
                        title     = { ucFirst(tip) }
                    >
                        { icon }
                    </Tooltip>);
                }
            }

            if( !label && name )
            {
                label = ucFirst(course.getLocaleName(lang)) ;
            }

            return (
                <Chip
                    color     = 'default'
                    icon      = { icon }
                    label     = { label }
                    onClick   = { () => history.push ( url.split(api.url)[1] ) }
                />
            )
        }
        return null;
    };

    getLocale = () => this.props.locale.things.game.quests.application ;

    onCardClick = child  => () =>
    {
        if( child instanceof Thing )
        {
            const { url } = child ;
            if( isString(url) )
            {
                const { history } = this.props ;
                history.push( url.split(api.url)[1] );
            }
        }
    };

    prepare = item =>
    {
        let {
            name,
            about
        } = item ;

        if( about instanceof Thing )
        {
            about = String(about.id)
        }
        else
        {
            about = null ;
        }

        return (
            {
                name,
                about
            });
    };
}

ApplicationQuest.defaultProps =
{
    ...ThingCardChildren.defaultProps ,
    activable      : false ,
    animate        : true ,
    clazz          : Game,
    containerProps :
    {
        className : "bg-transparent w-full px-16",
        elevation : 0,
        square    : true
    },
    badge    : true ,
    icon     : <MapIcon/>,
    itemGrid :
    {
        xl : 12 ,
        lg : 12 ,
        md : 12 ,
        sm : 12 ,
        xs : 12
    },
    member    : 'quest',
    removeUri : api.games.courses.url
};

ApplicationQuest.propTypes =
{
    ...ThingCardChildren.propTypes
};

export default compose( withStyles( styles ) , withRouter , initApp )( ApplicationQuest ) ;
